module.exports = __webpack_public_path__ + "static/fonts/Franklin Gothic Medium.45a9841.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Franklin Gothic Medium.ttf
// module id = zTd5
// module chunks = 8